import { useNavigate } from 'react-router-dom';
import { message } from 'antd';

import { Links } from 'links';

import { IdDto } from 'codegen';

import { useGetLazyRequest } from '../api';

export const useStartCorrection = () => {
  const navigate = useNavigate();

  const config = useGetLazyRequest<IdDto>({
    url: '/snaps/corrections',
    options: {
      onSuccess: ({ data, status }) => {
        if (status === 204) {
          navigate(Links.Queues);
          message.info('No snaps that require Operator attention are available in this queue. Please select another queue.');

          return;
        }

        navigate(`${Links.Snaps}/${data.id}`);
      },
      onError: ({ response }) => {
        if (response?.status === 412) {
          message.info('No queue assigned to current Operator. Please select queue.');
          navigate(Links.Queues);
        }
      },
    },
  });

  return config;
};
